import React, { memo, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { currencyFormatter, getMessage } from 'util/locale';
import { convertPlantingPlanParams } from 'util/parse';
import { FocusInput } from 'common/FocusInput';
import { inferUnit } from 'util/unitConversion';

type GrainPriceInputProps = {
  currency: string;
  disabled?: boolean;
};

export const GrainPriceInput = memo(function GrainPriceInput({
  currency,
  disabled = false,
}: GrainPriceInputProps) {
  const { control } = useFormContext();
  const cost = useMemo(() => currencyFormatter(0, currency), [currency]);
  const unit = useMemo(() => inferUnit('mass.yield').symbol.quantitySpecific, []);

  return (
    <Controller
      control={control}
      name="grainPrice"
      render={({ field, fieldState: { error } }) => {
        const { display, displayValue } = convertPlantingPlanParams({
          validationResult: undefined,
          value: field.value,
          currency,
        });

        return (
          <FocusInput
            label={getMessage('bulk-fvss-review-scripts-grain-price-label', {
              unit: inferUnit('mass.yield').label.universal,
            })}
            placeholder={`${cost}/${unit}`}
            error={error?.message}
            onChange={(e) => field.onChange(e.target.value)}
            onBlur={field.onBlur}
            testId="grain-price-input"
            showLabel={true}
            showReset={false}
            value={display}
            displayValue={displayValue}
            disabled={disabled}
          />
        );
      }}
    />
  );
});
